import { useParams, Link, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);

  if (!currentCategory) {
    return <Navigate to="/" replace />;
  }

  const articles = getArticlesByCategory(slug || '');

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${currentCategory.name} - 老色哥穿搭指南`,
        description: currentCategory.description,
        url: `https://www.laosege.com/category/${slug}`,
      }} />

      <main>
        <div className="bg-background-100/50 border-b border-background-200/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 pt-20 md:pt-24 pb-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: currentCategory.name },
              ]}
            />
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600">
                <i className={`${currentCategory.icon} text-2xl md:text-3xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  {currentCategory.name}
                </h1>
                <p className="text-sm text-foreground-600 mt-1">{currentCategory.description}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="flex flex-col lg:flex-row gap-8">
            <aside className="lg:w-56 flex-shrink-0">
              <nav className="lg:sticky lg:top-24" aria-label="分类导航">
                <h3 className="text-sm font-semibold text-foreground-900 mb-3 lg:mb-4">所有分类</h3>
                <div className="flex lg:flex-col gap-2 flex-wrap">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className={`inline-flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-all duration-200 whitespace-nowrap ${
                        cat.slug === slug
                          ? 'bg-primary-100/80 text-primary-700 font-medium'
                          : 'text-foreground-600 hover:bg-background-100 hover:text-primary-600'
                      }`}
                    >
                      <i className={`${cat.icon} text-base`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </nav>
            </aside>

            <div className="flex-1 min-w-0">
              {articles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {articles.map((article) => (
                    <ArticleCard key={article.slug} article={article} variant="default" />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 mx-auto mb-4">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-600">该分类暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}